var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"app-content"},[_vm._v("404 - Page not found")])])
}]

export { render, staticRenderFns }